module.exports = __webpack_public_path__ + "static/media/left.40b5ffe8.svg";